export default "__VITE_ASSET__D2HVo_88__"